import {
    grayColor
} from "assets/jss/material-kit-pro-react.js";

const FooterStyle = {
    left: {
        float: "left!important",
        display: "block"
    },
    footerBrand: {
        height: "50px",
        padding: "15px 15px",
        fontSize: "18px",
        lineHeight: "50px",
        marginLeft: "-15px",
        color: grayColor[1],
        textDecoration: "none",
        fontWeight: 700,
        fontFamily: "Roboto Slab,Times New Roman,serif"
    },
    pullCenter: {
        display: "inline-block",
        float: "none"
    },
    rightLinks: {
        float: "right!important",
        "& ul": {
            marginBottom: 0,
            padding: 0,
            listStyle: "none",
            "& li": {
                display: "inline-block"
            },
            "& a": {
                display: "block"
            }
        },
        "& i": {
            fontSize: "20px"
        }
    },
};

export default FooterStyle;
